import { atom } from 'jotai';
import { PurchaseBlockerModalType } from '../typings';

export const purchaseBlockerModalAtom = atom<PurchaseBlockerModalType | undefined>(undefined);
